import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ErrorMessage from './ErrorMessage';

interface ICkeditorProps {
  error?: string;
  value: string;
  disable?: boolean;
  onChange?: (data: string) => void;
}
const Ckeditor = ({ error, value, disable, onChange }: ICkeditorProps) => {
  return (
    <div className="custom-ckeditor">
      <CKEditor
        editor={ClassicEditor}
        data={value}
        disabled={disable}
        onChange={(_, editor) => onChange?.(editor.getData() ?? '')}
        config={{
          toolbar: [
            'heading',
            '|',
            'bold',
            'italic',
            'underline',
            'strikethrough',
            '|',
            'fontColor',
            'fontBackgroundColor',
            'fontFamily',
            'fontSize',
            'alignment',
            '|',
            'link',
            'bulletedList',
            'numberedList',
            'blockQuote',
            'undo',
            'redo',
          ],
          image: {
            toolbar: [
              'imageStyle:alignLeft',
              'imageStyle:alignCenter',
              'imageStyle:alignRight',
              '|',
              'imageTextAlternative',
            ],
          },
          htmlSupport: {
            allow: [
              { name: /.*/, attributes: true, classes: true, styles: true },
            ],
          },
        }}
      />

      <ErrorMessage message={error} />
    </div>
  );
};
export default Ckeditor;
